<template>
  <div class="formationContainer">
    <h1><v-icon>school</v-icon> {{ $t('menu.formation')}}</h1>
    <div class="formBloq">
      <h2>{{ $t('formation.regulatedTraining') }}</h2>
      <v-expansion-panels>
        <v-expansion-panel v-for="(academic,i) in academics" :key="i" >
          <v-expansion-panel-header>{{ $t(academic.title) }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            {{ $t('academic.finished') }}: {{ academic.finished }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="formBloq">
      <h2>{{ $t('formation.furtherTraining') }}</h2>
      <div class="formationFilter">
        <v-text-field v-model="filterText" :label="$t('formation.filter')" type="input">
        </v-text-field>
        <v-btn density="compact" :disabled="filterText == ''" @click="filterText = ''">
          <v-icon color="info">delete</v-icon>
        </v-btn>
      </div>
      <v-expansion-panels>
        <v-expansion-panel v-for="(training,i) in trainingsFiltered" :key="i" >
          <v-expansion-panel-header>{{ training.title }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-if="training.description">{{training.description}}</div>
            {{ $t('academic.finished') }}: {{ training.finished }}
            <div v-if="training.pdfUrl">
              <a :href="training.pdfUrl" target="_blank">{{ $t('formation.cert') }}</a>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="footSpace"></div>
  </div>
</template>

<script>
export default {
  name: 'Formation',
  data: () => ({
    academics: [],
    trainings: [],
    filterText: '',
  }),
  methods: {  },
  computed: {
    trainingsFiltered() {
      return this.trainings.filter(train => train.title.toUpperCase().includes(this.filterText.toUpperCase()))
    },
  },
  created() {
    this.academics.push({ title: 'academic.daw', finished: 2019 })
    this.academics.push({ title: 'academic.asi', finished: 2010 })
    this.academics.push({ title: 'academic.ayf', finished: 2008 })
    this.academics.push({ title: 'academic.mht', finished: 1998 })
    this.academics.push({ title: 'academic.bac', finished: 1996 })

//    this.trainings.push({ title: 'Vue', finished: 2020, pdfUrl: '/resources/pdfs/Vue2020.pdf' })
    this.trainings.push({
      title: "Machine Learning and AI with Python (HarvardX)",
      finished: 2026,
      pdfUrl: 'https://courses.edx.org/certificates/3a1cd5265f3641dbab821ee81e80510f'
    })
    this.trainings.push({
      title: "Design Patterns in Java",
      finished: 2026,
      pdfUrl: 'http://ude.my/UC-42bd6224-d4ae-41e1-b30a-5964bdc57151'
    })
    this.trainings.push({
      title: "Microfrontends with React: A Complete Developer's Guide",
      finished: 2026,
      pdfUrl: 'http://ude.my/UC-5778fb79-f653-42ea-b280-4505d2a6f97c'
    })
    this.trainings.push({
      title: 'PyTorch for Deep Learning Bootcamp',
      finished: 2026,
      pdfUrl: 'http://ude.my/UC-9f8c8bdd-ff9e-45ee-8d13-497aaee1d6a6'
    })
    this.trainings.push({
      title: 'AI Agents & Workflows - The Practical Guide',
      finished: 2025,
      pdfUrl: 'http://ude.my/UC-1bff45ba-29e9-4b01-8bee-a32106ddbcfa'
    })
    this.trainings.push({
      title: 'LLM Engineering: Master AI, Large Language Models & Agents',
      finished: 2025,
      pdfUrl: 'http://ude.my/UC-bce55906-5296-4b28-aeab-86cb1a0ccf31'
    })
    this.trainings.push({
      title: 'Local LLMs via Ollama & LM Studio - The Practical Guide',
      finished: 2025,
      pdfUrl: 'http://ude.my/UC-b79a49d2-960e-4c88-9e2a-ee9e2290a8c2'
    })
    this.trainings.push({
      title: 'Web Components & Stencil.js - Build Custom HTML Elements',
      finished: 2024,
      pdfUrl: 'http://ude.my/UC-6362f846-bd65-4775-919e-16ca1cbeb3c1'
    })
    this.trainings.push({
      title: 'gRPC [Java] Master Class: Build Modern API & Micro services',
      finished: 2024,
      pdfUrl: 'http://ude.my/UC-7fd897f2-7bf5-4739-83c4-659b26b65f51'
    })
    this.trainings.push({
      title: 'Getting started with WebAssembly & Emscripten',
      finished: 2024,
      pdfUrl: 'http://ude.my/UC-734fe3f9-b084-45e7-a1ea-2227db8724f0'
    })
    this.trainings.push({
      title: 'HTMX - The Practical Guide',
      finished: 2024,
      pdfUrl: 'http://ude.my/UC-185de432-4920-4bb4-881c-dd5bb1bc000a'
    })
    this.trainings.push({
      title: 'Liderazgo y Gestión de Equipos - Estilos y Estrategias',
      finished: 2024,
      pdfUrl: 'http://ude.my/UC-0e5f9093-fc47-47fa-ab77-97d2e27484b5'
    })
    this.trainings.push({
      title: 'Nuxt.js 2 - Vue.js on Steroids',
      finished: 2023,
      pdfUrl: 'http://ude.my/UC-f904659f-ac3f-4c76-a6a6-7e5e87755c87'
    })
    this.trainings.push({
      title: 'Remix JS - The Practical Guide',
      finished: 2023,
      pdfUrl: 'http://ude.my/UC-40bef198-4f48-44cb-bfb0-f1f1f284d127'
    })
    this.trainings.push({
      title: 'Managing database versions with Liquibase and Spring Boot',
      finished: 2023,
      pdfUrl: 'http://ude.my/UC-0244c4f6-1ffd-47e3-9c57-0cd3f222137e'
    })
    this.trainings.push({
      title: 'Helm 3: Despliega aplicaciones en Kubernetes',
      finished: 2023,
      pdfUrl: 'http://ude.my/UC-d02c2460-4ad8-4758-ad5c-cd70acd968a2'
    })
    this.trainings.push({
      title: 'Monitoring and Alerting with Prometheus',
      finished: 2023,
      pdfUrl: 'http://ude.my/UC-82d6f4c4-2d20-4efa-93a4-454ed186c03f'
    })
    this.trainings.push({
      title: 'Ansible: Beginner to Pro',
      finished: 2023,
      pdfUrl: 'http://ude.my/UC-c74c040e-377e-4e24-b82f-713727782b56'
    })
    this.trainings.push({
      title: 'DevOps Project - 2022: CI/CD with Jenkins Ansible Kubernetes',
      finished: 2022,
      pdfUrl: 'http://ude.my/UC-81062963-b184-46cb-9521-989c40602222'
    })
    this.trainings.push({
      title: 'Practical OpenShift for Developers - OpenShift 4',
      finished: 2022,
      pdfUrl: 'http://ude.my/UC-a9593b9b-3f36-4309-b4ed-f6a17a74bbcc'
    })
    this.trainings.push({
      title: 'Terraform: Infraestructura como Código',
      finished: 2022,
      pdfUrl: 'http://ude.my/UC-01279f2e-86ab-4e1d-b509-7fc47d5e1a45'
    })
    this.trainings.push({
      title: 'Vue JS 3: Composition API (with Pinia & Vite)',
      finished: 2022,
      pdfUrl: 'http://ude.my/UC-11ce2d15-9d2a-4b13-8669-4481f77e9cce'
    })
    this.trainings.push({
      title: 'Vert.x - Reactive microservices with Java',
      finished: 2022,
      pdfUrl: 'http://ude.my/UC-0c324d8b-9ef8-471e-9d22-30de4bc7162b'
    })
    this.trainings.push({
      title: 'Quarkus Backend development with Java and GraalVM',
      finished: 2021,
      pdfUrl: 'http://ude.my/UC-468297a5-0835-471f-91c7-11911832d2cc'
    })
    this.trainings.push({
      title: 'Docker & Kubernetes',
      finished: 2021,
      pdfUrl: 'http://ude.my/UC-6160153f-92e4-4cfb-8c03-d03678cfc3ae'
    })
    this.trainings.push({
      title: 'React - The Complete Guide (incl Hooks, React Router, Redux)',
      finished: 2020,
      pdfUrl: 'http://ude.my/UC-4d027818-13b0-4e89-969b-356b26f2be72'
    })
    this.trainings.push({
      title: '3D Programming Three.js 3D Library',
      finished: 2020,
      pdfUrl: 'http://ude.my/UC-9ebd873c-1d32-47aa-9a28-314cf8a400d9'
    })
    this.trainings.push({
      title: 'Machine Learning in JavaScript with TensorFlow.js',
      finished: 2020,
      pdfUrl: 'http://ude.my/UC-eb927851-5433-456a-890f-51a1eae1368a'
    })
    this.trainings.push({
      title: 'Vue JS 2',
      finished: 2020,
      pdfUrl: 'http://ude.my/UC-ccf703dd-d551-4433-b716-496a3dd888f8'
    })
    this.trainings.push({
      title: 'C++ Programming',
      finished: 2020,
      pdfUrl: 'http://ude.my/UC-484494f4-246a-436c-b91b-dbd3ab022e51'
    })
    this.trainings.push({
      title: 'Geoserver Postgres and Openlayers 3',
      description: 'Internet Map Server application using Open Source GIS tools',
      finished: 2020,
      pdfUrl: 'http://ude.my/UC-b456eb13-5155-4967-9375-baf35675af34'
    })
    this.trainings.push({
      title: 'Jenkins, From Zero To Hero',
      finished: 2020,
      pdfUrl: 'http://ude.my/UC-493ab078-9c32-4d9b-8871-1158f5f085e9'
    })
    this.trainings.push({
      title: 'Webpack 4/5',
      finished: 2020,
      pdfUrl: 'http://ude.my/UC-a86a39bc-72f7-4e3c-baa6-7d34ac1f87a0'
    })
    this.trainings.push({
      title: 'Flutter Development with Dart',
      finished: 2019,
      pdfUrl: 'http://ude.my/UC-UL1WB9C6'
    })
    this.trainings.push({
      title: 'Backbone JS',
      finished: 2019,
      pdfUrl: 'http://ude.my/UC-INT5DZX9'
    })
    this.trainings.push({
      title: 'Machine Learning Data Science Python',
      finished: 2019,
      pdfUrl: 'http://ude.my/UC-E853AATO'
    })
    this.trainings.push({
      title: 'Python and Django Full Stack Web Developer',
      finished: 2019,
      pdfUrl: 'http://ude.my/UC-DT9UX7KJ'
    })
    this.trainings.push({
      title: 'Oracle PL/SQL',
      finished: 2018,
      pdfUrl: 'http://ude.my/UC-694X65NQ'
    })
    this.trainings.push({
      title: 'Spring Framework 5',
      finished: 2018,
      pdfUrl: 'http://ude.my/UC-2LW6USWZ'
    })
    this.trainings.push({
      title: this.$i18n.t('training.ionic'),
      finished: 2018,
      pdfUrl: 'http://ude.my/UC-5HPH7JDD'
    })
    this.trainings.push({
      title: this.$i18n.t('training.angular'),
      finished: 2017,
      pdfUrl: 'http://ude.my/UC-9NA8LH5B'
    })
    this.trainings.push({ title: 'Android Studio', finished: 2017 })
    this.trainings.push({ title: 'SQL Bases de Datos Relacionales', finished: 2003 })
    this.trainings.push({ title: 'Unix Avanzado', finished: 2003 })

  }
}
</script>


<style scoped>
  .formationContainer {
    margin: 20px;
  }

  .formBloq {
    margin: 20px;    
  }

  .footSpace {
    height: 5px;
  }

  .formationFilter {
    display: flex;
  }
</style>